/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { dvtVars } from '../../Common/themes/themeContract.css';

export function getChartVars() {
  return [
    {
      tokenVar: dvtVars.label.sm.fontSize,
      key: 'labelFontSize',
      cssProp: 'font-size'
    }
  ];
}
